import React, { useState, useEffect } from 'react';
import { Box, FormControl, FormGroup } from '@material-ui/core';
import { AudienceUriListItemComponent } from './audienceUriListItem.component';
import { useTypedTranslation } from '@app/hooks';
import { PasslyTextField } from '@app/components';

interface IProps {
    audienceUriList: string[];
    onAdd: (name: string, value: string[]) => void;
}

interface IIdpinitComponentState {
    newAudienceUri: string;
    audienceUriList: string[];
}

export const AddAudienceUriComponent: React.SFC<IProps> = ({ audienceUriList, onAdd }: IProps) => {
    const { translation } = useTypedTranslation();

    const [state, setState] = useState<IIdpinitComponentState>({
        newAudienceUri: '',
        audienceUriList: audienceUriList ?? []
    });

    useEffect(() => {
        onAdd('AudienceUris', state.audienceUriList);
    }, [state.audienceUriList]);

    // FUNCTIONS
    const addUri = () => {
        setState(prevState => ({
            ...prevState,
            audienceUriList: [
                ...prevState.audienceUriList,
                prevState.newAudienceUri
            ],
            newAudienceUri: ''
        }));
    };

    const removeUri = (index: number) => {
        const currentList = [...state.audienceUriList];
        currentList.splice(index, 1);
        setState(prevState => ({ ...prevState, audienceUriList: currentList }));
    };

    const handleTextInputChange = ({
        target: { name, value }
    }: React.ChangeEvent<HTMLInputElement>) => {
        setState(prevState => ({ ...prevState, [name]: value }));
    };

    const handleAudienceUriListItemEditSave = (
        audienceUriListItemValue: string,
        index: number
    ) => {
        const currentList = [...state.audienceUriList];
        currentList[index] = audienceUriListItemValue;
        setState(prevState => ({
            ...prevState,
            audienceUriList: [...currentList]
        }));
    };

    const audienceUriValid = () => !!state.newAudienceUri;

    return (
        <>
            {/* ADD_AUDIENCE_URI */}
            <FormControl>
                <PasslyTextField
                    name='newAudienceUri'
                    label={'ADD_AUDIENCE_URI'}
                    value={state.newAudienceUri}
                    id='audienceUri-input'
                    onChange={handleTextInputChange}
                    onAddButtonClick={audienceUriValid() ? addUri : undefined}
                    fullWidth
                />
            </FormControl>
            {state.audienceUriList?.length !== 0 &&
            <>
                <Box mb={1} mt={2} className='audienceuri-list__header'>
                    <h3>{translation('AUDIENCE_URI')}</h3>
                </Box>
                <FormGroup className='audienceuri-list__body'>
                    {state.audienceUriList?.map(
                        (audienceUri: string, index: number) => {
                            return (
                                <AudienceUriListItemComponent
                                    key={`${audienceUri}${index}`}
                                    index={index}
                                    audienceUri={audienceUri}
                                    onRemove={() => removeUri(index)}
                                    onSave={value =>
                                        handleAudienceUriListItemEditSave(
                                            value,
                                            index
                                        )
                                    }
                                />
                            );
                        }
                    )}
                </FormGroup>
            </>
            }
        </>
    );
};
